namespace GeniuzPOS.LogManage {
    export interface LogApiPathRow {
        Id?: number;
        ApiPath?: string;
        Path?: string;
        ApiDesc?: string;
        Paramiter?: string;
        CreatedBy?: string;
        CreatedDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
    }

    export namespace LogApiPathRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ApiPath';
        export const localTextPrefix = 'LogManage.LogApiPath';
        export const lookupKey = 'LogManage.LogApiPath';

        export function getLookup(): Q.Lookup<LogApiPathRow> {
            return Q.getLookup<LogApiPathRow>('LogManage.LogApiPath');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ApiPath = "ApiPath",
            Path = "Path",
            ApiDesc = "ApiDesc",
            Paramiter = "Paramiter",
            CreatedBy = "CreatedBy",
            CreatedDate = "CreatedDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate"
        }
    }
}
